import type { ProductCrudData } from './interfaces';

export const removeReplacesCode = (products: ProductCrudData[]): ProductCrudData[] => {
  return products.map(
    product => ({ ...product, replacesCode: null, replacedByCode: null, lockedByActionId: null }) as ProductCrudData,
  );
};
